import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

export const ALL = '__all';

/** Section filter limited to the sections the user may see (from /staff-attendance/sections). */
export const SectionSelect = ({ sections, value, onChange, testId = 'att-section-select', allowAll = true }) => (
  <Select value={value || ALL} onValueChange={(v) => onChange(v === ALL ? '' : v)}>
    <SelectTrigger className="w-[220px] bg-white" data-testid={testId}><SelectValue placeholder="Section" /></SelectTrigger>
    <SelectContent>
      {allowAll && <SelectItem value={ALL}>All my sections</SelectItem>}
      {sections.map((s) => <SelectItem key={s.key} value={s.section} data-testid={`${testId}-opt-${s.key}`}>{s.section} ({s.staff_count})</SelectItem>)}
    </SelectContent>
  </Select>
);

/** Regular / Contract filter (Staff Master 'worker_type'). */
export const WorkerTypeSelect = ({ value, onChange, testId = 'att-worker-select' }) => (
  <Select value={value || ALL} onValueChange={(v) => onChange(v === ALL ? '' : v)}>
    <SelectTrigger className="w-[160px] bg-white" data-testid={testId}><SelectValue placeholder="Worker type" /></SelectTrigger>
    <SelectContent>
      <SelectItem value={ALL} data-testid={`${testId}-opt-all`}>All workers</SelectItem>
      <SelectItem value="regular" data-testid={`${testId}-opt-regular`}>Regular</SelectItem>
      <SelectItem value="contract" data-testid={`${testId}-opt-contract`}>Contract</SelectItem>
    </SelectContent>
  </Select>
);

/** White / Blue collar filter (Staff Master 'collar'); 'none' = collar not set. */
export const CollarSelect = ({ value, onChange, testId = 'att-collar-select' }) => (
  <Select value={value || ALL} onValueChange={(v) => onChange(v === ALL ? '' : v)}>
    <SelectTrigger className="w-[180px] bg-white" data-testid={testId}><SelectValue placeholder="Collar" /></SelectTrigger>
    <SelectContent>
      <SelectItem value={ALL} data-testid={`${testId}-opt-all`}>All collars</SelectItem>
      <SelectItem value="white" data-testid={`${testId}-opt-white`}>White Collar</SelectItem>
      <SelectItem value="blue" data-testid={`${testId}-opt-blue`}>Blue Collar</SelectItem>
      <SelectItem value="none" data-testid={`${testId}-opt-none`}>Collar not set</SelectItem>
    </SelectContent>
  </Select>
);

export default SectionSelect;
